'use strict';

require('../../style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/index.js
 ** module id = 217
 ** module chunks = 0
 **/